import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "providers/logger";

const getUtilityConnectionUrl = async (jwt: string, prospectId: string) => {
  return await AmplifyPost<{ url: string }>(
    "Get Utility Connection Url",
    "OfferExpApi",
    `/prospect/${prospectId}/utility-connection-url`,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    logger
  );
};

export { getUtilityConnectionUrl };
